const elements = {
  searchToggles: document.body.querySelectorAll('.js-search-toggle'),
};

const parentActive = "search-is-active";
const active = "is-active";

function toggleHandler(toggle) {
  toggle.parentElement.classList.toggle(active);
  document.body.classList.toggle(parentActive);
  toggle.nextElementSibling.setAttribute(
    "aria-hidden",
    !toggle.parentElement.classList.contains(active)
  );
  if (document.body.classList.contains(parentActive)) {
    setTimeout(()=> {
      toggle.parentElement.querySelector('.c-search__input').focus();
    },100);
  }
}

function closeSearch(event) {
  if (document.body.classList.contains(parentActive)) {
    if (event.target.classList.contains('js-search-toggle')) return;
    elements.searchToggles.forEach((toggle) => {
      if (toggle.parentElement.contains(event.target)) return;
      if (toggle.parentElement.classList.contains(active)) {
        toggleHandler(toggle);
      }
    })
  }
}

function init() {
  if (elements.searchToggles.length) {
    elements.searchToggles.forEach((toggle) => {
      toggle.addEventListener("click", (event) => toggleHandler(event.target));
    });

    document.addEventListener('click', closeSearch);
  }
}

export default init;


// WEBPACK FOOTER //
// ./src/components/components/developers/search/search.js